import { z } from 'zod';
/**
 * Insurance-Claims-owned duplicate of the Assistant legacy claim-resolution
 * seam (consumer-contract duplication pattern — no cross-package import in
 * either direction). The slot string and payload shapes must stay identical
 * to `assistant-legacy-update-orchestration.contract.ts`; the executable
 * apps/api compatibility test enforces that.
 */
export const insuranceClaimsLegacyClaimResolutionCapability = 'insurance-claims.legacy-claim-resolution.v1';
export const insuranceClaimsLegacyClaimResolutionProviderId = insuranceClaimsLegacyClaimResolutionCapability;
export const insuranceClaimsLegacyClaimResolutionSlot = 'assistant.legacy-claim-resolution';
/** The Assistant-owned request version this provider accepts (duplicated). */
export const insuranceClaimsLegacyClaimResolutionRequestVersion = 'assistant.legacy-claim-resolution.v1';
export const insuranceClaimsLegacyClaimResolutionRequestSchema = z.strictObject({
    contractVersion: z.literal(insuranceClaimsLegacyClaimResolutionRequestVersion),
    requestId: z.string().uuid(),
    projectId: z.string().uuid(),
});
/**
 * `none` proves the Project has no eligible open, unarchived current claim.
 * More than one eligible claim is explicit ambiguity — the legacy flat-field
 * seam never picks "latest". `manageAuthorized` reports whether the current
 * member holds `insurance-claims.claims.manage`, so the Assistant
 * orchestration can authorize a deterministic claim creation without
 * importing this owner. Availability states are host-gate facts owned by the
 * Assistant orchestration, never returned from here.
 */
export const insuranceClaimsLegacyClaimResolutionResultSchema = z.discriminatedUnion('status', [
    z.strictObject({
        status: z.literal('resolved'),
        manageAuthorized: z.boolean(),
        tenantId: z.string().uuid(),
        projectId: z.string().uuid(),
        claimId: z.string().uuid(),
        revision: z.number().int().positive(),
        claimStatus: z.enum(['open', 'closed', 'cancelled']),
        archived: z.boolean(),
        carrierDisplayName: z.string().min(1).max(240).nullable(),
        claimNumber: z.string().min(1).max(120).nullable(),
        policyNumber: z.string().min(1).max(120).nullable(),
        adjusterDisplayName: z.string().min(1).max(240).nullable(),
        adjusterPhone: z.string().min(1).max(80).nullable(),
        adjusterEmail: z.string().email().max(320).nullable(),
        lossDate: z.string().date().nullable(),
    }),
    z.strictObject({ status: z.literal('none'), manageAuthorized: z.boolean() }),
    z.strictObject({
        status: z.literal('ambiguous'),
        manageAuthorized: z.boolean(),
        eligibleClaimCount: z.number().int().min(2),
    }),
]);
//# sourceMappingURL=insurance-claims-legacy-claim-resolution.contract.js.map